// extracted by mini-css-extract-plugin
module.exports = {"contents":"Qk-z","sectionHeading":"Rk-z"};